import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "content" }

import RoundedButton from "../RoundedButton.vue";

interface Props {
  visible: boolean;
  hoursUsed: number;
  setVisible: Function,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HoursUsedModal',
  props: {
    visible: { type: Boolean },
    hoursUsed: {},
    setVisible: { type: Function }
  },
  setup(__props: any) {

const BatteryGirl = require("../../assets/images/Battery-Girl.png") as string;

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: props.visible,
    modal: "",
    class: "hours-used-modal",
    closable: false,
    "aria-label": 'Hours Used Reminder',
    "close-on-escape": true
  }, {
    header: _withCtx(() => [
      _createElementVNode("img", {
        src: _unref(BatteryGirl),
        class: "header-image"
      }, null, 8, _hoisted_1),
      _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Reminder", -1))
    ]),
    footer: _withCtx(() => [
      _createVNode(RoundedButton, {
        text: "Dismiss",
        lessRound: "",
        accent: "",
        fitWidth: "",
        uppercase: "",
        tall: "",
        onClick: () => props.setVisible && props.setVisible(false),
        "enter-press": () => props.setVisible && props.setVisible(false),
        ariaLabel: 'Dismiss'
      }, null, 8, ["onClick", "enter-press"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, " You’ve used " + _toDisplayString(props.hoursUsed) + " out of your 30-hour recording limit. Just a heads-up to keep you in the loop. ", 1),
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "Subscribe now to unlock unlimited recording and more features!", -1))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})